import { Button, Card, CardTitle } from '@invested/ui';
import { exportParticipantsCsvUrl } from '../../services/api';

export function ExportPage() {
  return (
    <div className="max-w-xl space-y-6">
      <CardTitle as="h1">Eksport</CardTitle>
      <Card size="lg">
        <CardTitle as="h2">Deltakere (CSV)</CardTitle>
        <p className="mt-2 text-sm text-black/60">
          Eksporterer pseudonyme deltakerdata (pseudonym-ID, status, alder, kjønn, samtykke, prøve- og
          referansetesttelling) til analyse. Inneholder ingen direkte identifiserende opplysninger.
        </p>
        <a href={exportParticipantsCsvUrl()} className="mt-4 inline-block">
          <Button>Last ned participants.csv</Button>
        </a>
      </Card>
    </div>
  );
}
